module.exports = __webpack_public_path__ + "img/33_25.3cb78c8f.png";